import { HttpApi } from 'src/services/api/common/http/HttpApi';
import { Api } from 'src/services/api/reallis/Api';
export { DataType } from 'src/services/api/common/http/HttpApi';
const ws1 = new Api({
    url: process.env.API_URL,
});
export const api = {
    http: new HttpApi({
        authController: ws1.auth,
    }),
    ws: {
        ws1,
    },
};
